<script setup lang="ts">
import { onMounted, ref, set } from 'vue'
import { KS } from '@/kuaishou'
import { $log } from '@/helpers'
import { useToastStore } from '@/stores'

defineProps<{
  contentId: string
  chapterId: string
}>()

const { $toast } = useToastStore()

onMounted(async () => {
  fetchAd()
})

const adImagePlayer = ref(false)
const adImageData = ref({ caption: '', coverUrl: '', h5Data: {} as any, detailSessionId: '' })
async function fetchAd() {
  const result = await KS.getAdImage()
  $log('component: BizAdBottom', '#getAdImage', { result })
  const { detailSessionId, adData, error_msg } = result

  if (!adData) {
    $toast(error_msg)
    return
  }

  adImagePlayer.value = true
  let h5Data: any = {}
  try {
    h5Data = JSON.parse(adData.h5Data)
  }
  catch (error) {
    $log('component: BizAdBottom', '#getAdImage ~> parse H5Data', { error })
  }
  adImageData.value.coverUrl = adData.coverUrl.replace('.kpg', '.png') // replace extension
  adImageData.value.caption = adData.caption
  adImageData.value.detailSessionId = detailSessionId
  set(adImageData.value, 'h5Data', h5Data)
}

function refresh() {
  $log('component: BizAdBottom', '#refresh')
  adImageData.value = {} as any
  fetchAd()
}

function onOpenAd() {
  KS.openAdImageDetail(adImageData.value.detailSessionId)
}

defineExpose({
  refresh,
})
</script>

<template>
  <BizTrackShow
    v-if="adImageData.detailSessionId"
    name="readPageBottomAd" type="block" :extra="{ contentId, chapterId }"
    class="w-full h-18 px-4 flex items-center justify-between fixed left-0 bottom-0 shadow-2xl"
  >
    <img class="w-85px h-48px rounded" :src="adImageData.coverUrl" alt="图片:广告封面">
    <div class="mx-2 flex flex-1 flex-col space-y-2" style="width: calc(100vw - 200px);">
      <p class="w-full text-sm font-bold truncate">
        {{ adImageData.caption }}
      </p>
      <p class="w-22px text-#0000004D text-8px text-center lh-12px border border-#0000004D rounded-1px">
        广告
      </p>
    </div>
    <BizTrackClick
      v-if="adImageData.h5Data"
      name="readPageBottomAd" type="button" :extra="{ contentId, chapterId }"
      class="w-20 block py-1.5 text-13px text-white text-center bg-primary rounded-full"
      @click="onOpenAd"
    >
      查看详情
    </BizTrackClick>
  </BizTrackShow>
</template>
